import * as productActionTypes from "ActionTypes/productActionTypes";
import productInitialState from "InitialStates/productInitialState";
const reducers = {
  setCatalog: (state, action) => {
    return {
      ...state,
      catalog: action.catalog
    };
  },
  setPricing: (state, action) => {
    return {
      ...state,
      catalogWithPrice: action.catalogWithPrice
    };
  },
  setProducts: (state, action) => {
    return {
      ...state,
      products: action.products
    };
  },
  changeIOShipOption: (state, action) => {
    return {
      ...state,
      ioShipMethod: action.option
    };
  },
  setSelectedPack: (state, action) => {
    return {
      ...state,
      selectedPacks: action.packs
    };
  },
  setSelectedPackItem: (state, action) => {
    return {
      ...state,
      selectedPackItem: action.selectedPackItem
    };
  },
  clearSelectedPack: (state, action) => {
    return {
      ...state,
      selectedPacks: []
    };
  },
  clearSelectedPackItem: (state, action) => {
    return {
      ...state,
      selectedPackItem: []
    };
  }
};

const productReducer = (state = productInitialState, action) => {
  switch (action.type) {
    case productActionTypes.SET_CATALOG:
      return reducers.setCatalog(state, action);
    case productActionTypes.SET_PRICING:
      return reducers.setPricing(state, action);
    case productActionTypes.SET_PRODUCTS:
      return reducers.setProducts(state, action);
    case productActionTypes.CHANGE_IO_SHIP_OPTIONS:
      return reducers.changeIOShipOption(state, action);
    case productActionTypes.SET_SELECTED_PACK:
      return reducers.setSelectedPack(state, action);
    case productActionTypes.SELECTED_PACK:
      return reducers.setSelectedPackItem(state, action);
    case productActionTypes.CLEAR_SELECTED_PACK:
      return reducers.clearSelectedPack(state, action);
    case productActionTypes.CLEAR_SELECTED_PACK_ITEM:
      return reducers.clearSelectedPackItem(state, action);
    default:
      return state;
  }
};

export default productReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/productReducer.js